import { Editor } from "@craftjs/core";
import ButtonBlock from "@/components/editor/blocks/ButtonBlock";
import SocialMediaBlock from "@/components/editor/blocks/SocialMediaBlock";
import MapBlock from "@/components/editor/blocks/MapBlock";
import FaqsBlock from "@/components/editor/blocks/FaqsBlock";
import DishBlock from "@/components/editor/blocks/DishBlock";
import MenuBlock from "@/components/editor/blocks/MenuBlock";
import CartBlock from "@/components/editor/blocks/CartBlock";
import ContainerBlock from "@/components/editor/blocks/ContainerBlock";
import TextBlock from "@/components/editor/blocks/TextBlock";
import ImageBlock from "@/components/editor/blocks/ImageBlock";
import VerticalSpacerBlock from "@/components/editor/blocks/VerticalSpacerBlock";
import SectionBlock from "@/components/editor/blocks/section-block/SectionBlock";
import RenderNode from "@/features/websites/components/RenderNode";
import Canvas from "../components/Canvas";
import RegionBlock from "@/components/editor/blocks/RegionBlock";
import RepeatBlock from "@/components/editor/blocks/RepeatBlock";
import CarouselBlock from "@/components/editor/blocks/CarouselBlock";
import { CircularProgress } from "@mui/material";
import { EmptyState } from "@/components";
import FormBlock from "@/components/editor/blocks/FormBlock";
import TextInputBlock from "@/components/editor/blocks/TextInputBlock";
import NumberInputBlock from "@/components/editor/blocks/NumberInputBlock";
import DateInputBlock from "@/components/editor/blocks/DateInputBlock";

interface Props {
    isLoading: boolean;
    json: string | null;
}

const WebComponentReader = ({ isLoading, json }: Props) => {
    if (isLoading) {
        return (
            <CircularProgress />
        )
    }

    if (!json) {
        return (
            <EmptyState
                title="Contenido no encontrado"
                description="Vuelve a intentarlo mas tarde"
            />
        )
    }

    return (
        <Editor
            resolver={{
                FormBlock,
                TextInputBlock,
                NumberInputBlock,
                DateInputBlock,
                SectionBlock,
                ContainerBlock,
                TextBlock,
                ImageBlock,
                CarouselBlock,
                VerticalSpacerBlock,
                ButtonBlock,
                SocialMediaBlock,
                MapBlock,
                FaqsBlock,
                DishBlock,
                MenuBlock,
                CartBlock,
                RegionBlock,
                RepeatBlock,
            }}
            enabled={false}
            onRender={RenderNode}
        >
            <Canvas json={json} />
        </Editor>
    )
}

export default WebComponentReader;
